import { Component, OnInit } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DocumentReader } from 'src/app/modules/core/store/models';
import moment from 'moment';
import { CultureService } from 'src/app/modules/core/services/culture.service';

@Component({
    selector: 'app-date-time-cell',
    templateUrl: './date-time-cell.component.html',
    styleUrls: ['./date-time-cell.component.scss'],
    standalone: false
})
export class DateTimeCellComponent implements OnInit {
  value: any;

  constructor(private cultureService: CultureService) {}

  ngOnInit(): void {}

  agInit(params: any): void {
    const document = params.data;
    const reader = new DocumentReader(document);
    const field = params.schemaField;

    if (!!params.data) {
      this.value = reader.getFormattedFieldValue(field.systemName, field, this.cultureService);
    } else {
      this.value =
        !!params.value && moment(params.value).isValid()
          ? reader.formatDate(params.value, field?.settings?.format, this.cultureService)
          : null;
    }
  }
}
